<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand text-light p-0 m-0" href="#">
      <span class="row m-0 p-0">
        <span class="col-3 m-0 p-0">
          <img src="zignflix_logo.png" alt="Application Name" class="logo-text" height="">
        </span>
        <span class="col-9 m-0 p-0">
          <span class="row m-0 p-1">
            <span class="col-12 m-0 p-0">ADMIN</span>
            <span class="col-12 version m-0 p-0">{{version}}</span>
          </span>
        </span>
      </span>
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="appRoutes.dashboard" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="appRoutes.businessList" routerLinkActive="active">Business</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="appRoutes.adManager" routerLinkActive="active">Ad Manager</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="appRoutes.screensList" routerLinkActive="active">Screens</a>
        </li>
      </ul>
      <button matButton (click)="logout()"> <mat-icon>logout</mat-icon> Logout</button>
    </div>
  </div>
</nav>
